require('./styles.css');
import React from 'react';

export class Title extends React.Component {
  render () {
    return (
      <div className="title">
        <h1>Idle Hands</h1>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/title/index.js